import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { BaseFormComponent } from '../../../core/abstractions/base-form.component';
import { EntityTypeEnum } from '../../../models/enums/entity-type.enum';
import { ListTransactionModel } from '../../../models/list-transaction.model';
import { TransactionSummaryModel } from '../../../models/transaction-summary.model';
import { TransactionModel } from '../../../models/transaction.model';
import { MetaResource } from '../../../services/resources/meta.resource';
import { SecuritiesResource } from '../../../services/resources/securities.resource';
import { TransactionsResource } from '../../../services/resources/transactions.resource';

@Component({
    selector: 'sl-transactions-form',
    templateUrl: './transactions-form.component.html',
    styleUrls: ['./transactions-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TransactionsFormComponent
    extends BaseFormComponent<TransactionModel, TransactionSummaryModel, ListTransactionModel>
    implements OnInit
{
    readonly EntityTypeEnum = EntityTypeEnum;

    transactionTypeName = '';
    securityName = '';
    totalNumberOfShares = 0;

    protected override readonly _entityResource = inject(TransactionsResource);

    private readonly securitiesResource = inject(SecuritiesResource);
    private readonly metaResource = inject(MetaResource);

    override ngOnInit(): void {
        super.ngOnInit();
        this.setupForm();

        const loadingStatusSub = this.loadingStatusChange.subscribe(isLoading => {
            if (!isLoading && this.record) {
                this.metaResource
                    .getTransactionType(this.record.outgoingAccountTypeId, this.record.incomingAccountTypeId)
                    .subscribe(r => (this.transactionTypeName = r.value.label));
                this.securitiesResource.get(this.record.securityId.toString()).subscribe(r => {
                    this.securityName = r.value.name;
                    this.totalNumberOfShares = r.value.totalNumberOfShares;
                });
            }
        });

        this.addSubscriptions(loadingStatusSub);
    }

    private setupForm(): void {
        const controlValue = undefined;
        this.formGroup = new FormGroup({
            outgoingName: new FormControl(controlValue, undefined),
            incomingName: new FormControl(controlValue, undefined),
            numberOfShares: new FormControl(controlValue, undefined),
            registeredNumberOfShares: new FormControl(controlValue, undefined),
            valueDate: new FormControl(controlValue, undefined),
            remarks: new FormControl(controlValue, undefined),
            outgoingAccountTypeId: new FormControl(controlValue, undefined)
        });
    }
}
